import { defineStore } from "pinia";

export const useSignUp = defineStore("signUp", {
  state: () => ({
    signupUserData: {},
    otpVerification: {
      limit: 3,
      attempt: 0,
    },
  }),
  getters: {
    getOtpVerificationData(state) {
      return state.otpVerification;
    },
  },
  actions: {
    resetSignUpData() {
      this.signupUserData = {};
      this.otpVerification = {
        limit: 3,
        attempt: 0,
      };
    },
    async verifyAndCheckEmail(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.VERIFY_EMAIL,
          params
        );
        return response.data;
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    async verifyAndCheckPhone(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.VERIFY_PHONE,
          params
        );
        return response.data;
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    async verifyAndCheckUserName(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.VERIFY_USERNAME,
          params
        );
        return response.data;
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    async verifyAndCheckLicense(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.VERIFY_LICENSE,
          params
        );
        return response.data;
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    async setDataInLns(params) {
      try {
        let response = await this.$request.post(
          "v1/customer/auth/register",
          params
        );
        return response.data;
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    async verifyOwnerShipByLicenceNumber(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.VERIFY_OWNERSHIP,
          params
        );
        return response.data;
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    async verifyOwnerShipByEmailOrPhone(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.VERIFY_OWNERSHIP_BY_EMAIL_OR_PHONE,
          params
        );
        return response.data;
      } catch (error) {
        return { status: false, message: error.message };
      }
    },
    incorrectOtpAttempt() {
      this.otpVerification.attempt += 1;
    },
    async registerFromIdentity(params) {
      try {
        const data = await this.$request.post(
          this.apiEndpoints.REGISTER_FROM_IDENTITY,
          params
        );
        if (data.data) {
          return data.data;
        }
      } catch (error) {}
    },
  },
});
